import { Identifiable } from "./identifiable";
import { project, Project } from "./project";
import { list, List } from "./list";
import { Task } from "./task";
import { id } from "./id";
import { status } from "./status";

type TaskRetrievalResponse = Identifiable<Task> & {
  list: Identifiable<List>;
  project: Identifiable<Project>;
};

const taskRetrievalResponse: TaskRetrievalResponse = {
  activityKeyRank: 0,
  allocations: [],
  description: "",
  endDate: "",
  createdDate: "",
  list: { ...list, uuid: id },
  name: "",
  percentComplete: 0,
  project: { ...project, uuid: id },
  startDate: "",
  status: { ...status, uuid: id },
  statusKeyRank: 0,
  tags: [],
  completionDate: "",
  uuid: "",
  duration: 0,
  minStartDate: "",
  maxEndDate: "",
  lastModified: "",
};

export type { TaskRetrievalResponse };

export { taskRetrievalResponse };
